import React from 'react';

const Header = () => {
  return (
    <>
      <header className="z-40 items-center w-full h-16 bg-white shadow-lg dark:bg-gray-700 rounded-2xl">
        <div className="relative z-20 flex flex-col justify-center h-full px-3 mx-auto flex-center">
          <div className="relative flex items-center w-full pl-1 lg:max-w-68 sm:pr-2 sm:ml-0">
            {/* <div class="relative p-1 flex items-center justify-end w-1/4 ml-5 mr-4 sm:mr-0 sm:right-auto">
              <a href="#" class="block relative">
                <img
                  alt="profil"
                  src="/images/person/1.jpg"
                  class="mx-auto object-cover rounded-full h-10 w-10 "
                />
              </a>
            </div> */}
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
